import { Box, Button, Modal, Stack } from '@mui/material'
import { useModal } from '../../../modules/layout/components/modals/useModal'
import { IModalProps } from '../../../modules/layout/components/modals/props'
import { WarningIcon } from '../../../modules/ConnectionIndicator/assets/WarningIcon'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '328px',
  backgroundColor: 'white',
  borderRadius: '4px',
  padding: '24px',
  border: 'none',
  outline: 'none',

  textAlign: 'center',
  color: '#222222',
  '& p': {
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '26px',
    '& span': {
      display: 'block',
      marginTop: '8px',
      fontWeight: '500',
    },
  },
  '& span': {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: '500',
  },
}

export const ReportErrorModal = ({open, handleClose}:IModalProps) => {

  return (
    <Modal
      onClose={handleClose}
      onClick={handleClose}
      open={open}
    >
      <Stack sx={style} gap={'24px'} alignItems={'center'} width={'100%'}>
        <svg
          width="92"
          height="92"
          viewBox="0 0 92 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M92 46C92 71.4051 71.4051 92 46 92C20.5949 92 0 71.4051 0 46C0 20.5949 20.5949 0 46 0C71.4051 0 92 20.5949 92 46ZM46 16.5C49.0376 16.5 51.5 18.9624 51.5 22V52C51.5 55.0376 49.0376 57.5 46 57.5C42.9624 57.5 40.5 55.0376 40.5 52V22C40.5 18.9624 42.9624 16.5 46 16.5ZM46 76C49.3137 76 52 73.3137 52 70C52 66.6863 49.3137 64 46 64C42.6863 64 40 66.6863 40 70C40 73.3137 42.6863 76 46 76Z"
            fill="#F0901E"
          />
        </svg>
        <p>
          Отчет формируется. Пожалуйста, ожидайте
        </p>
        <Stack gap={'8px'} width={'100%'}>
          <Button
            variant='contained'
            disableElevation
            fullWidth
            sx={{
              textTransform: 'none',
              backgroundColor: '#009FDA',
              '&:hover': {
                backgroundColor: '#007FBA',
              },
            }}
            onClick={handleClose}
          >
            Закрыть
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}
